module.exports = __webpack_public_path__ + "img/icon_file_p.4a78e23.png";